module.exports = __webpack_public_path__ + "img/check.08bfd4cc.svg";